// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#viewer {\r\n  height: calc(100% - var(--top-bar-height));\r\n}\r\n\r\n#viewer > .loadingTextDiv {\r\n  color: var(--text-secondary-color);\r\n  font-size: 30px;\r\n  height: 100%;\r\n  line-height: calc(100% - var(--top-bar-height));\r\n}\r\n\r\n.ViewerMain {\r\n  width: 100%;\r\n  height: 100%;\r\n  -webkit-transition: all 0.3s ease;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.ViewerMain > div {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
